export default "__VITE_ASSET__DwonXZVl__"